/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_Brain_TitleInputs */

const es_prompt_tips_brain_title = /** @type {(inputs: Prompt_Tips_Brain_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usá el modo Cerebro para consultas complejas`)
};

const en_prompt_tips_brain_title = /** @type {(inputs: Prompt_Tips_Brain_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Brain mode for complex queries`)
};

/**
* | output |
* | --- |
* | "Use Brain mode for complex queries" |
*
* @param {Prompt_Tips_Brain_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_brain_title = /** @type {((inputs?: Prompt_Tips_Brain_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_Brain_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_brain_title(inputs)
	return en_prompt_tips_brain_title(inputs)
});
export { prompt_tips_brain_title as "prompt_tips.brain_title" }